import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import React, { MouseEvent } from 'react';

const hideLabelsFor: Record<string, boolean> = {
  addRuleGroup: true,
  addRuleGroupExt: true,
  delGroup: true,
  delRuleGroup: true,
  delRule: true,
};

const typeToAriaLabel: Record<string, string> = {
  addRuleGroup: 'Add rule group',
  addRuleGroupExt: 'Add rule group',
  delGroup: 'Delete group',
  delRuleGroup: 'Delete rule group',
  delRule: 'Delete rule',
};

const typeToColor: Record<string, 'primary' | 'secondary'> = {
  addRule: 'primary',
  addGroup: 'primary',
  delGroup: 'secondary',
  delRuleGroup: 'secondary',
  delRule: 'secondary',
};

export type AccessibilityMuiButtonProps = {
  type: string;
  label?: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  readonly?: boolean;
  renderIcon?: (p: { type: string; readonly?: boolean }) => React.ReactNode;
};

export default function AccessibilityMuiButton({
  type,
  label,
  onClick,
  readonly,
  renderIcon,
}: AccessibilityMuiButtonProps) {
  const icon = renderIcon?.({ type, readonly });

  if (!label || hideLabelsFor[type]) {
    return (
      <IconButton
        size="small"
        disabled={readonly}
        onClick={onClick}
        color={typeToColor[type] ?? 'primary'}
        aria-label={typeToAriaLabel[type] ?? type}
      >
        {icon}
      </IconButton>
    );
  }
  return (
    <Button
      size="small"
      disabled={readonly}
      onClick={onClick}
      color={typeToColor[type] ?? 'primary'}
      startIcon={icon}
    >
      {label}
    </Button>
  );
}
